import { render } from "./NavCard.vue?vue&type=template&id=25cff4fe&scoped=true"
import script from "./NavCard.vue?vue&type=script&lang=js"
export * from "./NavCard.vue?vue&type=script&lang=js"

import "./NavCard.vue?vue&type=style&index=0&id=25cff4fe&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25cff4fe"]])

export default __exports__